import { fetchApiPorsche } from './fetchApiPorsche'

export function postPorsche(url, options) {
  return fetchApiPorsche(url, {
    ...options,
    body: options?.body ? JSON.stringify(options.body) : '',
    method: 'POST',
  })
}
